/** Root-relative URL under Vite `base` (e.g. / or /dechess/). */
export function publicUrl(path = '') {
  const base = import.meta.env.BASE_URL || '/';
  const normalized = String(path || '').replace(/^\//, '');
  return `${base}${normalized}`;
}
